import { render } from "./SlideHeaderMobile.vue?vue&type=template&id=0afc361b&ts=true"
import script from "./SlideHeaderMobile.vue?vue&type=script&lang=ts"
export * from "./SlideHeaderMobile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__